import { Component } from '@angular/core';
import { RouteDetailModalPresenter } from '../route-report-modal/route-detail-modal.presenter';

@Component({ selector: 'route-passengers-modal', templateUrl: './route-passengers-modal.component.html' })
export class RoutePassengersModalComponent extends RouteDetailModalPresenter {
  readonly kind = 'passengers' as const;
}
